export const INTERNAL_SERVER_ERROR_MESSAGE = 'Internal Server Error. Please, contact the administrator.';
export const NOT_FOUND_ERROR_MESSAGE = 'Requested entity was not found.';
